import { render, staticRenderFns } from "./BetslipBetSingleA.vue?vue&type=template&id=a1fe66a6&scoped=true"
import script from "./BetslipBetSingleA.vue?vue&type=script&lang=js"
export * from "./BetslipBetSingleA.vue?vue&type=script&lang=js"
import style0 from "./BetslipBetSingleA.vue?vue&type=style&index=0&id=a1fe66a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fe66a6",
  null
  
)

export default component.exports